import React from 'react';
import { Space, Switch, Typography } from 'antd';
import { DeleteTwoTone, EditTwoTone } from '@ant-design/icons';
import get from 'lodash/get';
import { Link } from 'react-router-dom';
import { hasAnyPermission, replaceMultiple } from '../utilities/helpers';
import { EDIT_OFFERINGS } from './routes';
import {
  ROLE_ADMIN,
  ROLE_MANAGER,
  ROLE_MARKETING_ADMIN,
  ROLE_MARKETING_MANAGER,
} from './roles';

const { Text } = Typography;

export const offeringsTableColumn = ({
  roleCode,
  onConfirmDelete,
  updateOfferingStatus,
  hasEditPermission,
  hasDeletePermission,
  onViewDetails,
}) =>
  [
    {
      title: 'Offering Code',
      key: 'code',
      dataIndex: 'code',
      render: (text, record) => (
        <Text
          className="text-theme-color"
          onClick={() => {
            onViewDetails(record);
          }}
          underline
        >
          {text}
        </Text>
      ),
    },
    {
      title: 'Brand',
      key: 'brand',
      dataIndex: ['Company', 'name'],
      hidden: hasAnyPermission([ROLE_ADMIN, ROLE_MANAGER], [roleCode]),
    },
    {
      title: 'Name of Offering',
      key: 'name',
      dataIndex: 'name',
      sorter: true,
    },
    {
      title: 'Number of Items',
      key: 'items',
      dataIndex: 'item_count',
      sorter: true,
    },
    {
      title: 'Marketplace',
      key: 'marketplace',
      dataIndex: 'SalesChannel',
      render: (salesChannel) => {
        return get(salesChannel, 'name');
      },
    },
    {
      title: 'Availability',
      key: 'availability',
      dataIndex: 'availability',
      render: (availability) => {
        return availability === 'SELECTIVE' ? 'Selective' : 'Public';
      },
    },
    {
      title: 'MRP/Offerings',
      key: 'mrp',
      dataIndex: 'mrp',
    },
    {
      title: 'Discount Offered(%)',
      key: 'discount_percent',
      dataIndex: 'discount_percent',
      render: (discount) => (discount ? `${discount}%` : '--'),
      sorter: true,
    },
    {
      title: 'Status',
      key: 'is_active',
      render: (record) => (
        <Switch
          checked={get(record, 'is_active')}
          onChange={(checked) => {
            updateOfferingStatus(
              get(record, 'company_id'),
              get(record, 'id'),
              checked
            );
          }}
        />
      ),
    },
    {
      title: 'Action',
      key: 'action',
      render: (record) => (
        <Space size="large">
          {hasDeletePermission && (
            <DeleteTwoTone
              className="table-icon"
              twoToneColor="#009EA8"
              onClick={() => {
                onConfirmDelete(get(record, 'id'), get(record, 'company_id'));
              }}
            />
          )}
          {hasEditPermission && (
            <Link
              to={replaceMultiple(EDIT_OFFERINGS, {
                ':companyId': get(record, 'company_id'),
                ':id': get(record, 'id'),
              })}
            >
              <EditTwoTone className="table-icon" twoToneColor="#009EA8" />
            </Link>
          )}
        </Space>
      ),
    },
  ].filter((item) => !item.hidden);

export const offeringTableFilterList = (salesChannelList, userComapnies) => [
  {
    type: 'Select',
    multipleMode: true,
    placeholder: 'Marketplace',
    options: salesChannelList,
    optionLabelKey: 'name',
    optionValueKey: 'id',
    dropdownKey: 'marketplace',
    chipValueKey: 'sales_channel_id',
    permissions: [
      ROLE_ADMIN,
      ROLE_MANAGER,
      ROLE_MARKETING_ADMIN,
      ROLE_MARKETING_MANAGER,
    ],
  },
  {
    type: 'Select',
    multipleMode: true,
    placeholder: 'Brand',
    options: userComapnies,
    optionLabelKey: 'Company.name',
    optionValueKey: 'Company.id',
    dropdownKey: 'brand',
    chipValueKey: 'company_id',
    permissions: [ROLE_MARKETING_ADMIN, ROLE_MARKETING_MANAGER],
  },
  {
    type: 'Select',
    multipleMode: true,
    placeholder: 'Availability',
    options: [
      {
        value: 'PUBLIC',
        label: 'Public',
      },
      {
        value: 'SELECTIVE',
        label: 'Selective',
      },
    ],
    optionLabelKey: 'label',
    optionValueKey: 'value',
    dropdownKey: 'availability',
    chipValueKey: 'availability',
    permissions: [
      ROLE_ADMIN,
      ROLE_MANAGER,
      ROLE_MARKETING_ADMIN,
      ROLE_MARKETING_MANAGER,
    ],
  },
  {
    type: 'Select',
    multipleMode: true,
    placeholder: 'Status',
    options: [
      {
        value: true,
        label: 'Active',
      },
      {
        value: false,
        label: 'Inactive',
      },
    ],
    optionLabelKey: 'label',
    optionValueKey: 'value',
    dropdownKey: 'showStatus',
    chipValueKey: 'is_active',
    permissions: [
      ROLE_ADMIN,
      ROLE_MANAGER,
      ROLE_MARKETING_ADMIN,
      ROLE_MARKETING_MANAGER,
    ],
  },
];
